module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/faq.json
// module id = 384
// module chunks = 84887730282209